// src/components/GalleryApps.jsx

import React, { useState, useMemo } from "react";
import GalleryCard from "./GalleryCard";

/* ===== 根据你的真实路径引入页面组件 ===== */
import LexPromptApp     from "../Lexprompt";
import LexNoteApp       from "../Lexnote/LexNoteApp";
import LexAcquire       from "../Lexacquire/LexAcquire";
import GenerativeSearch from "../LexGSEO/GenerativeSearch";
import { LexBuild }     from "../Lexbuild/LexBuild";
import ForYou           from "../pages/ForYou";
import Partners         from "../components/partners";

export default function GalleryApps() {
  // 数据驱动：key 决定唯一性 / icon 渲染 Dock 圆点 / component 是页面
  const apps = useMemo(() => [
    { key: "prompt",   icon: "⌑", title: "Lex Prompt",   component: <LexPromptApp /> },
    { key: "note",     icon: "⌇", title: "Lex Note",     component: <LexNoteApp /> },
    { key: "acquire",  icon: "⧈", title: "Lex Acquire",  component: <LexAcquire /> },
    { key: "gseo",     icon: "⧎", title: "Lex GSEO",     component: <GenerativeSearch /> },
    { key: "build",    icon: "⧝", title: "Lex Build",    component: <LexBuild /> },
    { key: "venture",  icon: "⌂", title: "Lex Venture",  component: <ForYou /> },
    { key: "partner",  icon: "⧉", title: "Lex Partner",  component: <Partners /> },
  ], []);

  const [activeKey, setActiveKey] = useState(null);
  const activeApp = apps.find(a => a.key === activeKey);

  return (
   <div className="gallery-apps">    {/* ← unique root */}
      {/*—— 内联样式 ——*/}
      <style>{`
        .gallery-dock {
          position: fixed;
          bottom: 24px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 24px;
          padding: 10px 20px;
          background: rgba(255,255,255,0.12);
          backdrop-filter: blur(22px) saturate(180%);
          -webkit-backdrop-filter: blur(22px) saturate(180%);
          border: 1px solid rgba(255,255,255,0.28);
          border-radius: 999px;
          box-shadow: 0 8px 26px rgba(0,0,0,0.35);
          z-index: 1000;
        }
        .dock-item {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #fff;
          cursor: pointer;
          user-select: none;
          transition: transform .25s cubic-bezier(.22,.61,.36,1),
                      background .25s ease,
                      box-shadow .25s ease;
        }
        .dock-item:hover {
          transform: translateY(-6px) scale(1.12);
        }
        .dock-item.active {
          background: linear-gradient(135deg, #4dffdf 0%, #5d9eff 100%);
          box-shadow: 0 4px 14px rgba(0,0,0,0.45);
        }
        @media (max-width: 600px) {
          .gallery-dock {
            bottom: 12px;
            gap: 12px;
            padding: 8px 16px;
          }
          .dock-item {
            width: 40px;
            height: 40px;
            font-size: 18px;
          }
        }
        @media (min-width: 601px) and (max-width: 900px) {
          .gallery-dock {
            bottom: 20px;
            gap: 16px;
            padding: 8px 16px;
          }
          .dock-item {
            width: 48px;
            height: 48px;
            font-size: 20px;
          }
        }
      `}</style>



      {/*—— 全屏面板 ——*/}
      <GalleryCard
        show={!!activeApp}
        title={activeApp?.title}
        onClose={() => setActiveKey(null)}
      >
        {activeApp?.component}
      </GalleryCard>

      {/*—— 底部 Dock ——*/}
      <div className="gallery-dock">
        {apps.map(app => (
          <div
            key={app.key}
            className={`dock-item${activeKey === app.key ? " active" : ""}`}
            title={app.title}
            onClick={() =>
              setActiveKey(prev => (prev === app.key ? null : app.key))
            }
          >
            {app.icon}
          </div>
        ))}
      </div>
    </div>
  );
}
